import ReactDOM from 'react-dom/client';
import BeamApp from './BeamApp';
import '@mercedes-benz/typeface-mb-corpo-a';
import '@mercedes-benz/typeface-mb-corpo-s';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// dont use strict mode
root.render(<BeamApp />);
